var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 105H30C23.3825 105 18 99.6175 18 93V27C18 20.3825 23.3825 15 30 15H90C96.6175 15 102 20.3825 102 27V93C102 99.6175 96.6175 105 90 105ZM30 21C26.6925 21 24 23.6925 24 27V93C24 96.3075 26.6925 99 30 99H90C93.3075 99 96 96.3075 96 93V27C96 23.6925 93.3075 21 90 21H30Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 36H21V42H42V36Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 36H51V42H66V36Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99 36H78V42H99V36Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51 51H45C41.6925 51 39 48.3075 39 45V36C39 32.6925 41.6925 30 45 30H51C54.3075 30 57 32.6925 57 36V45C57 48.3075 54.3075 51 51 51ZM45 36V45H51.0025V36H45Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39 72C34.0375 72 30 67.9625 30 63C30 58.0375 34.0375 54 39 54C43.9625 54 48 58.0375 48 63C48 67.9625 43.9625 72 39 72ZM39 60C37.345 60 36 61.345 36 63C36 64.655 37.345 66 39 66C40.655 66 42 64.655 42 63C42 61.345 40.655 60 39 60Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72C55.0375 72 51 67.9625 51 63C51 58.0375 55.0375 54 60 54C64.9625 54 69 58.0375 69 63C69 67.9625 64.9625 72 60 72ZM60 60C58.345 60 57 61.345 57 63C57 64.655 58.345 66 60 66C61.655 66 63 64.655 63 63C63 61.345 61.655 60 60 60Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81 72C76.0375 72 72 67.9625 72 63C72 58.0375 76.0375 54 81 54C85.9625 54 90 58.0375 90 63C90 67.9625 85.9625 72 81 72ZM81 60C79.345 60 78 61.345 78 63C78 64.655 79.345 66 81 66C82.655 66 84 64.655 84 63C84 61.345 82.655 60 81 60Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93C34.0375 93 30 88.9625 30 84C30 79.0375 34.0375 75 39 75C43.9625 75 48 79.0375 48 84C48 88.9625 43.9625 93 39 93ZM39 81C37.345 81 36 82.345 36 84C36 85.655 37.345 87 39 87C40.655 87 42 85.655 42 84C42 82.345 40.655 81 39 81Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60 93C55.0375 93 51 88.9625 51 84C51 79.0375 55.0375 75 60 75C64.9625 75 69 79.0375 69 84C69 88.9625 64.9625 93 60 93ZM60 81C58.345 81 57 82.345 57 84C57 85.655 58.345 87 60 87C61.655 87 63 85.655 63 84C63 82.345 61.655 81 60 81Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81 93C76.0375 93 72 88.9625 72 84C72 79.0375 76.0375 75 81 75C85.9625 75 90 79.0375 90 84C90 88.9625 85.9625 93 81 93ZM81 81C79.345 81 78 82.345 78 84C78 85.655 79.345 87 81 87C82.655 87 84 85.655 84 84C84 82.345 82.655 81 81 81Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51H69C65.6925 51 63 48.3075 63 45V36C63 32.6925 65.6925 30 69 30H75C78.3075 30 81 32.6925 81 36V45C81 48.3075 78.3075 51 75 51ZM69 36V45H75.0025V36H69Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.b2b63f63.svg";
export { ForwardRef as ReactComponent };